import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "src/app/data.service";
import { GUID } from "../../guid";
import { Location } from "@angular/common";

@Component({
  selector: "app-domain-confinew",
  templateUrl: "./domain-confinew.component.html",
  styleUrls: ["./domain-confinew.component.scss"],
})
export class DomainConfinewComponent implements OnInit {
  // domainForm: FormGroup;
  mode = "new";
  guid: GUID;
  domainSetting: any;
  doaminSettingId: string;
  isLoading = false;
  isError = false;
  domainForm = this.fb.group({
    name: [""],
    domainname: [""],
    description: [""],
    active: [false],
  });

  // doaminSettingId = "";
  errorMessage = "";

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private toastrService: ToastService,
    private location: Location,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.guid = new GUID();
    //  this.getDomainsetting();
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;

      this.doaminSettingId = this.route.snapshot.params.id;
    });

    if (this.mode.toLowerCase() == "edit") {
      this.getDomainsetting();
    }
    this.domainForm.get("name").valueChanges.subscribe((val) => {
      if (val && val.includes(" ")) {
        this.domainForm.get("name").setValue(val.replace(/\s+/g, ""), {
          emitEvent: false,
        });
      }
    });
  }

  removeSpaces(event: ClipboardEvent) {
    let paste = event.clipboardData.getData("text") || "";
    paste = paste.replace(/\s+/g, ""); // remove all spaces

    event.preventDefault();
    this.domainForm.get("name").setValue(paste);
  }
  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  save() {
    if (this.domainForm.controls["name"].value.toString().trim() == "") {
      this.showWarning("name is mandatory");
      return;
    }
    if (this.domainForm.controls["domainname"].value.toString().trim() == "") {
      this.showWarning("domainname is mandatory");
      return;
    }

    //  if (this.domainForm.controls["description"].value.toString().trim() == "") {
    //       // this.showWarning("Name is description");
    //       return;
    //   }

    if (this.mode.toLowerCase() == "new") {
      this.doaminSettingId = this.guid.getGUID("domainsetting");
    }

    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),

      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),

      data: {
        domainsetting: {
          id: this.doaminSettingId,
          metaapplicationid: localStorage.getItem("crm_metaapplicationid"),
          mode: this.mode,
          name: this.domainForm.controls["name"].value.trim(),
          domainname: this.domainForm.controls["domainname"].value.trim(),
          description: this.domainForm.controls["description"].value.trim(),
          active: this.domainForm.controls["active"].value,
        },
      },
    };

    console.log(postOption);
    this.isLoading = true;
    this.dataService.upsertDomainSetting(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          // this.router.navigateByUrl("home/domainsettinglist");
          this.location.back();
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
  cancel() {
    this.router.navigateByUrl("home/domainsettinglist");
  }

  getDomainsetting() {
    return new Promise((resolve, reject) => {
      console.log("getcrudmessages");

      // alert(id)
      const id = this.doaminSettingId;
      const organizationid = localStorage.getItem("crm_orgid");

      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      this.isLoading = true;
      this.dataService
        .getDomainsettingById(domain, subdomain, organizationid, id)
        .subscribe(
          (res) => {
            console.log("res", res);

            if (res.success == 1) {
              this.domainSetting = res.data.domainsetting[0];
              console.log("Doneeee****", this.domainSetting);

              if (this.domainSetting != null) {
                // this.dataSource = this.crudmessages.map((item) => ({
                //   id: item.id,
                //   // label: item.labelname,
                //   message: item.message,
                //   operation: item.operation.charAt(0).toUpperCase() + item.operation.slice(1),
                //   language: item.languagecode,
                //   // modifiedby: item.modifiedby,
                //   // modifieddate: item.modifieddate,
                //   // type: item.organizationid,
                //   // type: item.organizationid ? item.organizationid : 'common',
                //   type: item.organizationid ? 'Tenant' : 'Common',
                //   // content: item.content,
                //   // metalayoutid: item.metalayoutid,
                // }));
                this.domainForm.controls["name"].setValue(
                  this.domainSetting.name
                );
                this.domainForm.controls["domainname"].setValue(
                  this.domainSetting.label
                );

                this.domainForm.controls["description"].setValue(
                  this.domainSetting.description
                );

                this.domainForm.controls["active"].setValue(
                  this.domainSetting.active
                );
                // if (this.domainSetting.organizationid != null) {
                //   this.domainForm.controls["type"].setValue("tenant");
                // } else {
                //   this.domainForm.controls["type"].setValue("common");
                // }
              }

              this.isLoading = false;
            } else {
              console.log("Error while saving");
              this.isLoading = false;
            }
          },
          (err) => {
            console.log("Error***:", err);
            this.errorMessage = err.message;
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        );
    });
  }
}
